import apiClient from '~/services/api.service';
export const attributeService = {
    // async store(payload = {}) {
    //     return apiClient.post("products/attributes", payload);
    // },
    async index() {
        return apiClient.get("products/attributes");
    },
    async getAttribute(id) {
        return apiClient.get(`products/attributes/${id}`);
    },
};